<template>
  <v-container>
    <v-row>
      <v-col xs="12" cols="12" md="4">
        <v-list rounded>
          <v-subheader>Eduroam</v-subheader>
          <v-list-item-group v-model="active_num" color="#084776">
            <v-list-item v-for="(item, i) in items" :key="i" @click="active(item.num)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col xs="12" cols="12" md="8">
        <div v-for="(item, i) in tekstovi" :key="i" v-if="active_num == item.num">
          <h2 style="color: #084776">{{item.title}}</h2>
          <br />
          <p v-html="item.txt"></p>
        </div>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    item: 0,
    items: [
      { text: "Što je eduroam?", icon: "fas fa-question-circle", num: 0 },
      { text: "Korisničke informacije", icon: "fas fa-user-circle", num: 1 },
      { text: "Mjesta pristupa", icon: "fas fa-flag", num: 2 }
    ],
    active_num: 0,
    tekstovi: [
      {
        num: 0,
        title: "Što je eduroam?",
        txt: `Mogućnost spajanja na Internet različitim tehnologijama ugrađena je danas u većinu novih osobnih računala, tableta, PDA uređaja i mobitela. Također je uobičajeno nuditi roaming uslugu što podrazumijeva mogućnost pristupa mreži s različitih uređaja i lokacija uz uporabu jedinstvenoga elektroničkoga identiteta.<br><br>

                <a href="https://www.eduroam.org/" class="link" target="_blank">eduroam</a>™ (education roaming) je roaming-usluga zamišljena pod okriljem europske udruge akademskih i istraživačkih mreža (<a href="https://www.terena.org" class="link" target="_blank">TERENA</a>) i ostvarena kroz međunarodni projekt <a href="https://geant3plus.archive.geant.net/Pages/default.aspx" class="link" target="_blank">GÉANT</a>.<br><br>

                Usluga eduroam usmjerena je na omogućavanje bežičnog, ali i tzv. wired (žicom, kroz LAN) pristupa. Sveučilište u Mostaru zahvaljujući SUMIT-u i sustavu AAI@SUM je aktivno u izgradnji i pružanju usluge eduroam.<br><br>

                Autentikacija u sustavu eduroam temelji se na standardima 802.1x i zasniva na međunarodnoj hijerarhiji RADIUS poslužitelja u koju su uključeni i središnji poslužitelji sustava AAI@SUM.<br><br>
                
                <b>Usluga eduroam je sigurna, jednostavna i za krajnjeg korisnika potpuno besplatna usluga pristupa Internetu. Namjenjena je korisnicima iz sustava znanosti i obrazovanja.</b> Trenutno je dostupna na brojnim lokacijama na Sveučilištu u Mostaru te na više od 24000 <a href="https://monitor.eduroam.org/eduroam_map.php?type=levels" class="link" target="_blank">lokacija diljem svijeta</a>.`
      },
      {
        num: 1,
        title: "Korisničke informacije",
        txt: `Za spajanje na eduroam potrebno je posjedovati odgovarajući elektronički identitet i ispravno konfiguriran uređaj (računalo, tablet, mobilni telefon) za spajanje. Korisnici Sveučilišta u Mostaru koriste AAI@SUM elektronički identitet izdan od njihove matične ustanove. AAI@SUM korisničke oznake imaju karakterističan oblik:<br><br>
          
                <p class="text-center"><b>id_korisnika@id_ustanove</b></p> 
                
                (npr. pero@sum.ba) uz odgovarajuću lozinku (zaporku). Ako ga već ne posjedujete, iskoristite kontakt formu kako biste pronašli osobu odgovornu za izdavanje i upravljanje AAI@SUM elektroničkim identitetima.<br><br>
                
                Za sigurno i jednostavno konfiguriranje uređaja preporučamo korisnicima koji posjeduju AAI@SUM elektronički identitet korištenje alata <a href="https://installer.eduroam.hr/HomeOrg/sum.ba/" class="link" target="_blank">installer</a>.<br><br>
                
                Dodatne informacije i upute za korisnike potražite na stranicama za korisnike.`
      },
      {
        num: 2,
        title: "Mjesta pristupa",
        txt: `<table>
        <tr>
          <th>Lokacija uređaja</th>
          <th>Broj uređaja</th>
          </tr>
          <tr>
            <td>Sveučilište u Mostaru - Rektorat</td>
            <td>2</td>
          </tr>
          <tr>
            <td>Agronomski i prehrambeno-tehnološki fakultet</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Akademija likovnih umjetnosti</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Ekonomski fakultet</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Fakultet prirodoslovno-matematičkih i odgojnih znanosti</td>
            <td>6</td>
          </tr>
          <tr>
            <td>Fakultet strojarstva, računarstva i elektrotehnike</td>
            <td>14</td>
          </tr>
          <tr>
            <td>Fakultet zdravstvenih studija</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Farmaceutski fakultet</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Filozofski fakultet</td>
            <td>3</td>
          </tr>
          <tr>
            <td>Građevinski fakultet</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Medicinski fakultet</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Pravni fakultet</td>
            <td>1</td>
          </tr>
        </table>`
      }
    ],
    txt: ``
  }),
  methods: {
    active(data) {
      this.active_num = data;
    }
  }
};
</script>
